import dashboards from './dashboards'
import groups from './groups'

export default {
  dashboards,
  groups
}
